import { observer } from 'mobx-react-lite'
import { ContactsCleanupContent } from './ContactsCleanupContent/ContactsCleanupContent'

export const CleanupPage = observer(() => {
  return <ContactsCleanupContent />
})
